import { PromptRenderer } from "@nlux/react";
import { Space } from "antd";
import { CopyToClipboardButton } from "./CopyToClipboardButton";

export const MistralPromptRenderer: PromptRenderer = ({ prompt }) => {
  return (
    <>
      <div className="nlux-markdownStream-root">
        <div className="nlux-markdown-container">{prompt}</div>
      </div>
      <Space style={{ justifyContent: "end" }} className="nlux-actions" direction="vertical">
        <CopyToClipboardButton
          onClick={() => {
            navigator.clipboard.writeText(prompt);
          }}
        />
      </Space>
    </>
  );
};
